import { WholesaleCountsModel } from './../models/wholesale/wholesaleCounts.model';

import {throwError as observableThrowError,  Observable, of ,  Subject } from 'rxjs';

import {catchError} from 'rxjs/operators';
import { UserService } from 'app/services/user.service';
import { CountMessageEndpointType } from './menu.service';
import { WholesaleVehicleComment } from './../models/wholesale/wholesaleVehicleComment.model';
import { MenuService } from 'app/services/menu.service';
import { WholesaleVehicleOfferStatusEnum, WholesaleVehicleOfferType } from 'app/models/wholesale/wholesaleVehicleOffer.model';
import { WholesaleVehicleOfferModel } from 'app/models/wholesale/wholesaleVehicleOffer.model';

import { WholesaleSupplierModel } from 'app/models/wholesale/wholesaleSupplier.model';
import { WholesaleSupplierSearchResultModel } from 'app/models/wholesale/wholesaleSupplierSearchResult.model';
import { WholesaleSupplierSearchParamsModel } from 'app/models/wholesale/wholesaleSupplierSearchParams.model';

import { BooleanResultModel } from 'app/models/shared/booleanResult.model';
import { WholesaleVehicleModel } from 'app/models/wholesale/wholesaleVehicle.model';
import { ToastController, AlertController, NavController } from '@ionic/angular';
import { WholesaleVehicleSearchResultModel } from 'app/models/wholesale/wholesaleVehicleSearchResult.model';
import { WholesaleLookupModel } from 'app/models/wholesale/wholesaleLookup.model';
import { Constants } from 'app/utility/constants';
import { HttpClient, HttpParams } from '@angular/common/http';
import { WholesaleVehicleResultModel } from 'app/models/wholesale/wholesaleVehicleResult.model';
import { Injectable } from '@angular/core';
import { CacheService } from './cache.service';
import { WholesaleVehicleSearchParamsModel } from 'app/models/wholesale/wholesaleVehicleSearchParams.model';
import { StorageService } from 'app/services/storage.service';
import { WholesaleVehicleShortlistModel } from 'app/models/wholesale/wholesaleVehicleShortlist.model';

import { SecurityRight } from 'app/utility/enums';
import { DateHelper } from 'app/utility/datehelper';

export type offerStatus = 'pending' | 'won' | 'lost';

@Injectable({
	providedIn: 'root'
})
export class WholesaleService
{

	public vehicleMessage = new Subject<WholesaleVehicleResultModel>();

	currentDealership: WholesaleSupplierModel = null;

	constructor(
		private httpClient: HttpClient,
		private cache: CacheService,
		private toastController: ToastController,
		private alertController: AlertController,
		private navCtrl: NavController,
		private storage: StorageService,
		private menuService: MenuService,
		private userService: UserService
	)
	{

	}

	public getCachedVehiclesIndex(): Observable<string[]>
	{
		let cacheKey: string = 'wholesaleVehiclesIndex';
		let cacheMilliseconds: number = 1 * 60 * 60000; //1 hour
		return this.cache.get(cacheKey, this.getVehiclesIndex(), cacheMilliseconds);
	}

	public getVehiclesIndex(): Observable<string[]>
	{
		let httpParams = new HttpParams();
		return this.httpClient.get<string[]>(Constants.ApiUrl + 'vehicles/index', { params: httpParams });
	}


	public getVehicles(searchParams: WholesaleVehicleSearchParamsModel, suppressError = false): Observable<WholesaleVehicleSearchResultModel>
	{

		if (searchParams && searchParams.orderBy && searchParams.orderBy.includes("Desc"))
		{
			searchParams.orderBy = searchParams.orderBy.replace("Desc", "");
			searchParams.orderByDesc = true;
		}

		let httpParams = new HttpParams();
		for (var p in searchParams)
		{
			var val = searchParams[p];
			httpParams = httpParams.append(p, val);
		}
		return this.httpClient
			.get<WholesaleVehicleSearchResultModel>(Constants.ApiUrl + 'WholesaleVehicles', { params: httpParams }).pipe(
			catchError((e: any) => observableThrowError(this.errorHandler(e, suppressError))));
	}


	public getCachedRegions(): Observable<WholesaleLookupModel[]>
	{
		let cacheKey: string = 'WholesaleRegions';
		let cacheMilliseconds: number = 12 * 60 * 60000; //1 hour
		return this.cache.get(cacheKey, this.getRegions(), cacheMilliseconds);
	}

	private getRegions()
	{
		let httpParams = new HttpParams();
		return this.httpClient.get<WholesaleLookupModel[]>(Constants.ApiUrl + 'WholesaleLookups/Regions', { params: httpParams }).pipe(catchError((e: any) => observableThrowError(this.errorHandler(e, true))));
	}


	public getCachedManufacturers(): Observable<WholesaleLookupModel[]>
	{
		let cacheKey: string = 'WholesaleManufacturers';
		let cacheMilliseconds: number = 12 * 60 * 60000; //1 hour
		return this.cache.get(cacheKey, this.getManufacturers(), cacheMilliseconds).pipe(catchError((e: any) => observableThrowError(this.errorHandler(e, true))));
	}

	private getManufacturers()
	{
		let httpParams = new HttpParams();
		return this.httpClient.get<WholesaleLookupModel[]>(Constants.ApiUrl + 'WholesaleLookups/Manufacturers', { params: httpParams }).pipe(catchError((e: any) => observableThrowError(this.errorHandler(e, true))));
	}

	public getCachedBodyStyles(): Observable<WholesaleLookupModel[]>
	{
		let cacheKey: string = 'WholesaleBodyStyles';
		let cacheMilliseconds: number = 12 * 60 * 60000; //1 hour
		return this.cache.get(cacheKey, this.getBodyStyles(), cacheMilliseconds).pipe(catchError((e: any) => observableThrowError(this.errorHandler(e, true))));
	}

	private getBodyStyles()
	{
		let httpParams = new HttpParams();
		return this.httpClient.get<WholesaleLookupModel[]>(Constants.ApiUrl + 'WholesaleLookups/BodyStyles', { params: httpParams });
	}

	public getCachedFuelTypes(): Observable<WholesaleLookupModel[]>
	{
		let cacheKey: string = 'WholesaleFuelTypes';
		let cacheMilliseconds: number = 12 * 60 * 60000; //1 hour
		return this.cache.get(cacheKey, this.getFuelTypes(), cacheMilliseconds).pipe(catchError((e: any) => observableThrowError(this.errorHandler(e, true))));
	}

	private getFuelTypes()
	{
		let httpParams = new HttpParams();
		return this.httpClient.get<WholesaleLookupModel[]>(Constants.ApiUrl + 'WholesaleLookups/FuelTypes', { params: httpParams });
	}


	errorHandler(error: any, logOnly: boolean = false): void
	{
		console.error(error);
		if (logOnly) return;
		if (error.status == 500 || error.StatusCode == 500)
		{
			this.presentAlert("Server Error", 'An error occurred on the server. Please contact our support team if this error continues.');
		}
		else if (error.status == 404)
		{
			this.presentAlert("Not Found Error", 'This resource was not found. Please contact our support team if this error continues.');
		}
	}

	async presentToast(
		message: string,
		color?: 'primary' | 'secondary' | 'tertiary' | 'success' | 'warning' | 'danger' | 'light' | 'medium' | 'dark',
		position?: 'top' | 'bottom' | 'middle'
	)
	{
		const toast = await this.toastController.create({
			message: message,
			color: color,
			duration: 3000,
			animated: true,
			// buttons: [
			//   {
			// 	text: 'Close',
			// 	role: 'cancel',
			// 	handler: () => {
			// 	  console.log('Close clicked');
			// 	}
			//   }
			// ]
			position: position,
			layout: "stacked"
		});
		toast.present();
	}
	async presentAlert(title, message)
	{
		const alert = await this.alertController.create({
			header: title,
			message: message,
			buttons: [
				{
					text: 'Reload',
					role: 'cancel',
					cssClass: 'secondary',
					handler: (blah) =>
					{
						location.reload();
					}
				},
				{
					text: 'Go Back',
					handler: () =>
					{
						this.navCtrl.navigateRoot("/wholesale/vehicles");
					}
				}
			]
		});

		await alert.present();
	}

	getVehicleById(vehicleId: string): Observable<WholesaleVehicleModel>
	{
		return this.httpClient.get<WholesaleVehicleModel>(Constants.ApiUrl + 'WholesaleVehicles/' + vehicleId);
	}

	saveRecentVehicle(vehicle: WholesaleVehicleResultModel)
	{
		this.storage.get(Constants.IonicStorage_WholesaleRecentVehicles).then((val) =>
		{
			var recentVehicles = JSON.parse(val);
			if (!recentVehicles || !Array.isArray(recentVehicles))
			{
				recentVehicles = [];
			}
			else
			{
				recentVehicles = recentVehicles.filter(item => item.vehicleID !== vehicle.vehicleID); //remove vehicle if it is there already
			}

			recentVehicles.unshift(vehicle);

			if (recentVehicles.length > 20)
			{
				recentVehicles = recentVehicles.slice(0, 20);
			}
			this.storage.set(Constants.IonicStorage_WholesaleRecentVehicles, JSON.stringify(recentVehicles));
			localStorage.setItem('wholesale-recent-vehicles-initialised', 'true');
		});
	}

	shortlistVehicle(vehicleID: number, shortlist: boolean): Observable<WholesaleVehicleShortlistModel>
	{
		return this.httpClient.patch<WholesaleVehicleShortlistModel>(Constants.ApiUrl + 'WholesaleVehicles/' + vehicleID + '/Shortlist/' + shortlist, '');
	}

	saveVehicleNotes(vehicleID: number, notes: string): Observable<WholesaleVehicleShortlistModel>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.set('notes', notes);
		return this.httpClient.put<WholesaleVehicleShortlistModel>(Constants.ApiUrl + 'WholesaleVehicles/' + vehicleID + '/Notes', httpParams);
	}
	saveVehicleCommentOrQuestion(vehicleID: number, question: string, myVehicle: boolean): Observable<WholesaleVehicleComment>
	{
		if (myVehicle)
		{
			return this.saveVehicleComment(vehicleID, 0, question);
		}
		else
		{
			return this.saveVehicleQuestion(vehicleID, question);
		}
	}

	saveVehicleQuestion(vehicleID: number, question: string): Observable<WholesaleVehicleComment>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.set('question', question);
		return this.httpClient.post<WholesaleVehicleComment>(Constants.ApiUrl + 'WholesaleVehicles/' + vehicleID + '/Comments', httpParams);
	}

	saveVehicleComment(vehicleID: number, questionID: number, comment: string): Observable<WholesaleVehicleComment>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.set('comment', comment);
		return this.httpClient.patch<WholesaleVehicleComment>(Constants.ApiUrl + 'WholesaleVehicles/' + vehicleID + '/Comments/' + questionID, httpParams);
	}

	public getSuppliers(searchParams: WholesaleSupplierSearchParamsModel): Observable<WholesaleSupplierSearchResultModel>
	{

		if (searchParams.orderBy.includes("Desc"))
		{
			searchParams.orderByDesc = true;
		}
		switch (searchParams.orderBy)
		{
			case "CreatedDateDesc":
				searchParams.orderBy = "CreatedDate";
				break;
			case "DealershipNameDesc":
				searchParams.orderBy = "DealershipName";
				break;
		}

		let httpParams = new HttpParams();
		for (var p in searchParams)
		{
			var val = searchParams[p];
			httpParams = httpParams.append(p, val);
		}
		return this.httpClient
			.get<WholesaleSupplierSearchResultModel>(Constants.ApiUrl + 'WholesaleSuppliers', { params: httpParams }).pipe(
			catchError((e: any) => observableThrowError(this.errorHandler(e))));
	}

	public getCachedSuppliersIndex(searchParams: WholesaleSupplierSearchParamsModel): Observable<string[]>
	{
		let cacheKey: string = 'wholesaleSuppliersIndex';
		let cacheMilliseconds: number = 1 * 60 * 60000; //1 hour
		for (var p in searchParams)
		{
			cacheKey += searchParams[p];
		}
		if (searchParams.preferredSuppliers)
		{
			cacheMilliseconds = 1 * 30000; //1 minute
		}
		return this.cache.get(cacheKey, this.getSuppliersIndex(searchParams), cacheMilliseconds);
	}

	public getSuppliersIndex(searchParams: WholesaleSupplierSearchParamsModel): Observable<string[]>
	{
		let httpParams = new HttpParams();

		for (var p in searchParams)
		{
			var val = searchParams[p];
			httpParams = httpParams.append(p, val);
		}
		return this.httpClient.get<string[]>(Constants.ApiUrl + 'WholesaleSuppliers/index', { params: httpParams });
	}


	public objectLoadError: boolean = false;
	public handleError(error: any, logOnly: boolean = true): void
	{
		this.userService.handleError(error);
		this.objectLoadError = true;
	}


	favouriteSupplier(dealershipID: number, favourite: boolean): Observable<BooleanResultModel>
	{
		return this.httpClient.patch<BooleanResultModel>(Constants.ApiUrl + 'WholesaleSuppliers/' + dealershipID + '/Favourite/' + favourite, '');
	}

	public getCachedSupplierById(dealershipID: string): Observable<WholesaleSupplierModel>
	{
		let cacheKey: string = 'wholesaleSupplierById' + dealershipID;
		let cacheMilliseconds: number = 1 * 60 * 60000; //1 hour
		return this.cache.get(cacheKey, this.getSupplierById(dealershipID), cacheMilliseconds);
	}

	getSupplierById(dealershipID: string): Observable<WholesaleSupplierModel>
	{
		return this.httpClient.get<WholesaleSupplierModel>(Constants.ApiUrl + 'WholesaleSuppliers/' + dealershipID);
	}

	makeOffer(vehicleID: number, amount: number, buyerComment: string): Observable<WholesaleVehicleOfferModel>
	{
		return this.doMakeOffer(vehicleID, amount, buyerComment, "Offer")
	}

	buyNow(vehicleID: number, amount: number, buyerComment: string): Observable<WholesaleVehicleOfferModel>
	{
		return this.doMakeOffer(vehicleID, amount, buyerComment, "BuyNow")
	}

	doMakeOffer(vehicleID: number, amount: number, buyerComment: string, offerType: WholesaleVehicleOfferType): Observable<WholesaleVehicleOfferModel>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.set('amount', amount + "");
		httpParams = httpParams.set('buyerComment', buyerComment);
		httpParams = httpParams.set('offerType', offerType);
		return this.httpClient.post<WholesaleVehicleOfferModel>(Constants.ApiUrl + 'WholesaleVehicles/' + vehicleID + '/Offers', httpParams);
	}

	saveVehicleOfferResponse(vehicleID: number, vehicleOfferID: number, offerStatus: WholesaleVehicleOfferStatusEnum, comment: string): Observable<WholesaleVehicleOfferModel>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.set('offerStatus', offerStatus);
		httpParams = httpParams.set('sellerComment', comment);
		// console.log(httpParams);
		return this.httpClient.patch<WholesaleVehicleOfferModel>(Constants.ApiUrl + 'WholesaleVehicles/' + vehicleID + '/Offers/' + vehicleOfferID, httpParams);
	}

	withdrawOffer(vehicleID: number, vehicleOfferID): Observable<WholesaleVehicleOfferModel>
	{
		return this.httpClient.delete<WholesaleVehicleOfferModel>(Constants.ApiUrl + 'WholesaleVehicles/' + vehicleID + '/Offers/' + vehicleOfferID);
	}

	public getVehicleOffers(vehicleID: string): Observable<WholesaleVehicleOfferModel[]>
	{
		let httpParams = new HttpParams();

		return this.httpClient
			.get<WholesaleVehicleOfferModel[]>(Constants.ApiUrl + 'WholesaleVehicles/' + vehicleID + '/Offers', { params: httpParams });
	}

	public async initialiseCurrentDealership()
	{
		return of(this.getCurrentDealership());
	}

	public getCurrentDealership(bypassCache: boolean = false): Observable<WholesaleSupplierModel>
	{
		let cacheKey: string = 'currentWholesaleDealership';
		let cacheMilliseconds: number = 5 * 60000; //5 minutes
		if (bypassCache)
		{
			this.cache.clear(cacheKey);
		}
		// console.log("fetching current dealership");
		return this.cache.get(cacheKey, this.fetchCurrentDealership(), cacheMilliseconds);

	}

	private fetchCurrentDealership(): Observable<WholesaleSupplierModel>
	{
		return this.httpClient.get<WholesaleSupplierModel>(Constants.ApiUrl + 'WholesaleSuppliers/CurrentDealership');
	}


	public getOutgoingOffers(status: WholesaleVehicleOfferStatusEnum): Observable<WholesaleVehicleOfferModel[]>
	{
		return this.httpClient.get<WholesaleVehicleOfferModel[]>(Constants.ApiUrl + 'WholesaleOffers/Outgoing/' + status);
	}
	public getOutgoingOfferVehicles(status: WholesaleVehicleOfferStatusEnum): Observable<WholesaleVehicleResultModel[]>
	{
		return this.httpClient.get<WholesaleVehicleResultModel[]>(Constants.ApiUrl + 'WholesaleVehicles/Buying/' + status);
	}

	public getIncomingOffers(status: WholesaleVehicleOfferStatusEnum): Observable<WholesaleVehicleOfferModel[]>
	{
		return this.httpClient.get<WholesaleVehicleOfferModel[]>(Constants.ApiUrl + 'WholesaleOffers/Incoming/' + status);
	}
	public getIncomingOfferVehicles(status: WholesaleVehicleOfferStatusEnum): Observable<WholesaleVehicleResultModel[]>
	{
		return this.httpClient.get<WholesaleVehicleResultModel[]>(Constants.ApiUrl + 'WholesaleVehicles/Selling/' + status);
	}

	public getUnansweredQuestions(): Observable<WholesaleVehicleComment[]>
	{
		return this.httpClient.get<WholesaleVehicleComment[]>(Constants.ApiUrl + 'WholesaleComments/Questions');
	}

	public getIncomingQuestionVehicles(status: WholesaleVehicleOfferStatusEnum): Observable<WholesaleVehicleResultModel[]>
	{
		return this.httpClient.get<WholesaleVehicleResultModel[]>(Constants.ApiUrl + 'WholesaleVehicles/Questions');
	}

	public getFormattedDateTime(date: Date)
	{
		return DateHelper.getFormattedDateTime(date);
	}

	async updateMenuCounts(buying: boolean = true, selling: boolean = true)
	{
		if ( !this.userService.mcMinVersion("3.2.10")) {
			const buyingAccess = this.userService.hasExtendedRightAsync(SecurityRight.ToolsDealerzoneWholesaleBuying);
			const sellingAccess = this.userService.hasExtendedRightAsync(SecurityRight.ToolsDealerzoneWholesale);

			var self = this;

			if (buyingAccess && buying) {
				self.updateMenuCount("WholesaleCounts/Vehicles/Recommended");
				self.updateMenuCount("WholesaleCounts/Vehicles/Shortlist");
				self.updateMenuCount("WholesaleCounts/Offers/Outgoing/PendingAcceptance");
				self.updateMenuCount("WholesaleCounts/Offers/Outgoing/SellerAccepted");
				self.updateMenuCount("WholesaleCounts/Offers/Outgoing/SellerRejected");
			}
			if (sellingAccess && selling) {
				self.updateMenuCount("WholesaleCounts/Offers/Incoming/PendingAcceptance");
				self.updateMenuCount("WholesaleCounts/Offers/Incoming/SellerAccepted");
				self.updateMenuCount("WholesaleCounts/Offers/Incoming/SellerRejected");
				self.updateMenuCount("WholesaleCounts/Vehicles/Selling");
				self.updateMenuCount("WholesaleCounts/UnansweredQuestions");
			}
		}
		else {
			setTimeout(() =>
			{
				this.getCounts().subscribe(
					result =>
					{
						this.menuService.doCountMessages(result);
					}
				);
			}, 1500);
		}
	}

	updateMenuCount(endpoint: CountMessageEndpointType)
	{
		setTimeout(() =>
		{
			this.getCountForEndpoint(endpoint).subscribe(
				countresult =>
				{
					this.menuService.doCountMessage(endpoint, countresult);
				}
			);
		}, 1500);
	}

	getCountForEndpoint(endpoint: CountMessageEndpointType): Observable<number>
	{
		return this.httpClient.get<number>(Constants.ApiUrl + endpoint);
	}

	getCounts(): Observable<WholesaleCountsModel>
	{
		return this.httpClient.get<WholesaleCountsModel>(Constants.ApiUrl + "WholesaleCounts/All");
	}

}
